import React, { useState, useEffect } from 'react';
import { Button, Group, HoverCard, Select, Text } from '@mantine/core';
import { getAllProducts, getAllByCategory } from '../../Constant/Api/Api';
import { FaRegEdit, FaQuestionCircle } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { CiImageOn } from "react-icons/ci";
import EditProduct from './EditProduct';
import DeleteProduct from './DeleteProduct';
import CreateProduct from './CreateProduct';
import BrnadImages from './BrandImages/BrandImages';
import CategoryFAQModal from '../category/FAQ/CategoryFAQModal';
import Product from '../Product';
import ProductFAQModal from './FAQ/ProductFAQModal';
import { getAllSubCategory } from '../../Constant/Api/Api';

// Helper function to format file size
// const formatFileSize = (bytes) => {
//     if (bytes === 0) return '0 Bytes';
//     const k = 1024;
//     const sizes = ['Bytes', 'KB', 'MB', 'GB'];
//     const i = Math.floor(Math.log(bytes) / Math.log(k));
//     return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
// };

// Helper function to get image URL from different formats
const getImageUrl = (image) => {
    console.log("Image Type:", image);

    if (typeof image === 'string') {
        return image; // Old format
    }
    if (typeof image === 'object' && image.url) {
        return image.url; // New format
    }
    return null;
};

// Helper function to get image size from different formats
const getImageSize = (image) => {
    if (typeof image === 'object' && image.metaData && image.metaData.sizeOfImage) {
        return image.metaData.sizeOfImage;
    }
    return 0; // Default for old format or missing data
};

function ShowProducts() {
    const [productData, setProductData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [brandImagesModalOpen, setBrandImagesModalOpen] = useState(false);
    const [faqModalOpen, setFaqModalOpen] = useState(false);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);
    const [subCategoryData, setSubCategoryData] = useState([]);

    useEffect(() => {
        fetchProductData();
        fetchCategoryData();
        fetchSubCategoryData();
        fetchSubCategoryData();
    }, []);

    const fetchProductData = async () => {
        try {
            const token = localStorage.getItem('token');

            const response = await fetch(getAllProducts, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch product data');
            }

            const data = await response.json();
            setProductData(data);
        } catch (error) {
            console.error('Error fetching product data:', error);
        }
    };

    const fetchCategoryData = async () => {
        try {
            const token = localStorage.getItem('token');

            const response = await fetch(getAllByCategory, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch category data');
            }

            const data = await response.json();
            setCategoryData(data);
        } catch (error) {
            console.error('Error fetching category data:', error);
        }
    };

    const fetchSubCategoryData = async () => {
        try {
            const token = localStorage.getItem('token');

            const response = await fetch(getAllSubCategory, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch subcategory data');
            }

            const data = await response.json();
            setSubCategoryData(data);
        } catch (error) {
            console.error('Error fetching subcategory data:', error);
        }
    };

    const openEditModal = (product) => {
        setSelectedProduct(product);
        setEditModalOpen(true);
    };

    const closeEditModal = () => {
        setSelectedProduct(null);
        setEditModalOpen(false);
        fetchProductData();
    };

    const openDeleteModal = (product) => {
        setSelectedProduct(product);
        setDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setSelectedProduct(null);
        setDeleteModalOpen(false);
        fetchProductData();
    };

    const openBrandImagesModal = (product) => {
        setSelectedProduct(product);
        setBrandImagesModalOpen(true);
    };

    const closeBrandImagesModal = () => {
        setSelectedProduct(null);
        setBrandImagesModalOpen(false);
        fetchProductData();
    };

    const openProductFaqModal = (product) => {
        setSelectedProduct(product);
        setFaqModalOpen(true);
    };

    const closeProductFaqModal = () => {
        setSelectedProduct(null);
        setFaqModalOpen(false);
    };

    const filteredProducts = productData.filter(product =>
        (!selectedCategory || product.category?._id === selectedCategory) &&
        (!selectedSubCategory || product.subCategory?._id === selectedSubCategory)
    );

    return (
        <div>
            <h1 className="text-2xl font-bold mb-4 text-center">ShowProducts</h1>
            <div className='flex justify-between mx-12 mb-8'>
                <Select
                    placeholder="Select a category"
                    data={categoryData.map(category => ({ value: category._id, label: category.name }))}
                    value={selectedCategory}
                    onChange={(value) => {
                        console.log("Selected Category:", value);
                        setSelectedCategory(value);
                        setSelectedSubCategory(null); // Reset subcategory when category changes
                    }}
                    clearable
                    className="flex-1"
                />

                <Select
                    placeholder="Select a subcategory"
                    data={
                        // Filter subcategories based on selected category with null checks
                        selectedCategory
                            ? subCategoryData
                                .filter(subCategory =>
                                    subCategory.category && // Check if category exists
                                    subCategory.category._id === selectedCategory // Use _id instead of id
                                )
                                .map(subCategory => ({ value: subCategory._id, label: subCategory.name }))
                            : subCategoryData.map(subCategory => ({ value: subCategory._id, label: subCategory.name }))
                    }
                    value={selectedSubCategory}
                    onChange={setSelectedSubCategory}
                    clearable
                    className="flex-1"
                    disabled={!selectedCategory} // Disable if no category is selected
                />
                <CreateProduct fetchProductData={fetchProductData} />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xxl:grid-cols-4 gap-4">
                {filteredProducts.map((product) => {
                    // Get the first image for display
                    const firstImage = product?.images?.[0] || product?.productImage;
                    const imageUrl = getImageUrl(firstImage);
                    const imageSize = getImageSize(firstImage);
                    {
                        console.log("Product Image URL:", imageUrl);
                    }
                    return (
                        <div key={product._id} className="bg-white rounded-lg overflow-hidden shadow-xl">
                            <div className="relative">
                                <img
                                    src={imageUrl}
                                    alt={product.name}
                                    className="w-full h-48 object-scale-down"
                                />
                                {imageSize > 0 && (
                                    <div className="absolute top-2 right-2 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs">
                                        {imageSize} KB
                                    </div>
                                )}
                            </div>

                            <div className="p-4">
                                <div className="flex flex-row justify-end text-2xl space-x-2 cursor-pointer">
                                    <div onClick={() => openProductFaqModal(product)}>
                                        <FaQuestionCircle className="text-green-700 cursor-pointer" />
                                    </div>
                                    <div onClick={() => openBrandImagesModal(product)}>
                                        <CiImageOn className="text-green-700 cursor-pointer" />
                                    </div>
                                    <div onClick={() => openEditModal(product)}>
                                        <FaRegEdit />
                                    </div>
                                    <div onClick={() => openDeleteModal(product)}>
                                        <MdDelete className="text-red-700 cursor-pointer" />
                                    </div>
                                </div>
                                <h2 className="text-xl font-bold mb-2">Name: {product.name}</h2>
                                <Group justify="">
                                    <HoverCard width={280} shadow="md">
                                        <HoverCard.Target>
                                            <Button variant="filled" size="xs">
                                                <Text size="sm" fw={700}> Hover To read description</Text>
                                            </Button>
                                        </HoverCard.Target>
                                        <HoverCard.Dropdown>
                                            <Text size="sm">
                                                {product.description}
                                            </Text>
                                        </HoverCard.Dropdown>
                                    </HoverCard>
                                </Group>
                                <p className="text-gray-700">Category: {product?.category?.name || "Category might have been deleted"}</p>
                                <p className="text-gray-700">SubCategory: {product?.subCategory?.name || "SubCategory might have been deleted"}</p>
                                <p className="text-gray-700">Selling Price: ₹{product.sellingPrice}</p>
                                <p className="text-gray-700">MRP: ₹{product.mrp}</p>
                                <p className="text-gray-700">Slug: {product.slug}</p>

                                {/* Display image count and total size */}
                                {product.images && product.images.length > 0 && (
                                    <div className="mt-2">
                                        <p className="text-gray-700 font-bold">
                                            Total Images: {product.images.length}

                                        </p>
                                        <div className="grid grid-cols-4 gap-1 mt-1">
                                            {product.images.slice(0, 4).map((img, index) => (
                                                <div key={index} className="relative">
                                                    <img
                                                        src={getImageUrl(img)}
                                                        alt={`Thumb ${index}`}
                                                        className="w-full h-12 object-cover rounded"
                                                    />
                                                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white text-xs px-1 rounded-b">
                                                        {/* {formatFileSize(getImageSize(img))} */}
                                                        {getImageSize(img)} KB
                                                    </div>
                                                </div>
                                            ))}
                                            {product.images.length > 4 && (
                                                <div className="bg-gray-200 rounded flex items-center justify-center text-xs">
                                                    +{product.images.length - 4}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {product.specifications && product.specifications.length > 0 && (
                                    <div>
                                        <p className="text-gray-700 font-bold">Specifications:</p>
                                        {product.specifications.map((spec, index) => (
                                            <div key={index} className="text-gray-700 text-sm">
                                                <strong>{spec.key}:</strong> {Array.isArray(spec.value) ? spec.value.join(', ') : spec.value}
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {product.tags && product.tags.length > 0 && (
                                    <div className="mt-2">
                                        <h3 className="text-gray-700 font-bold">Tags:</h3>
                                        {product.tags.map((tag, index) => (
                                            <span key={index} className="text-gray-700 text-sm bg-gray-200 rounded-full px-2 py-1 mr-2">
                                                {tag}
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
            {editModalOpen && <EditProduct product={selectedProduct} onClose={closeEditModal} />}
            {deleteModalOpen && <DeleteProduct product={selectedProduct} onClose={closeDeleteModal} />}
            {brandImagesModalOpen && <BrnadImages product={selectedProduct} onClose={closeBrandImagesModal} />}
            {faqModalOpen && <ProductFAQModal product={selectedProduct} onClose={closeProductFaqModal} />}
        </div>
    );
}

export default ShowProducts;